import React from 'react';
import clsx from 'clsx';
import type {SetOptional} from 'type-fest';
import {i18n} from '@netx/core/i18n';
import {faTimes as TimesIcon} from '@netx/core-icons';
import {
	IconButton,
	type IconButtonProps,
} from '@netx/core-components/IconButton';
import {
	composeClasses,
	styled,
	type WithClasses,
} from '@netx/core-components/Theme';
import {
	getSearchFilterEndAdornmentClassesUtilityClass,
	type SearchFilterEndAdornmentClasses,
} from './searchFilterEndAdornmentClasses';

const useUtilityClasses = (ownerState: any) => {
	const {classes} = ownerState;
	const slots = {
		root: ['root'],
	};
	return composeClasses(
		slots,
		getSearchFilterEndAdornmentClassesUtilityClass,
		classes,
	);
};

export const SearchFilterEndAdornmentRoot = styled(IconButton, {
	name: 'SearchFilter',
	slot: 'EndAdornment',
})(({theme}) => ({
	position: 'absolute',
	right: 8,
}));

export interface SearchFilterEndAdornmentProps
	extends
		SetOptional<Omit<IconButtonProps, 'classes' | 'icon'>, 'label'>,
		WithClasses<SearchFilterEndAdornmentClasses> {
	'data-testid'?: string;
	hide?: boolean;
}

export const SearchFilterEndAdornmentPrimitive = ({
	classes: _classes,
	className,
	hide,
	...props
}: SearchFilterEndAdornmentProps) => {
	const classes = useUtilityClasses({
		classes: _classes,
	});

	if (hide) return null;

	return (
		<SearchFilterEndAdornmentRoot
			className={clsx(classes.root, className)}
			color="inherit"
			icon={TimesIcon}
			label={i18n.t('i18n.clear')}
			size="small"
			{...props}
		/>
	);
};

export const SearchFilterEndAdornment = SearchFilterEndAdornmentPrimitive;
export default SearchFilterEndAdornment;
